import { ScrollContainer } from '@codezo/ui';
import { RegularUsersTable } from '../components/RegularUsersTable';

export function RegularUsersPage() {
	return (
		<ScrollContainer>
			<RegularUsersTable />
		</ScrollContainer>
	);
}
